const UAParser = require("ua-parser-js");
const userAgentParser = new UAParser();
// Default hardcoded key
let deviceId = "";
let deviceRealModel = "";
let deviceFirmwareVersion = "";
let serverVersion = "";

export const device = {
  async getId() {
    try {
      if (typeof Hisense_GetDeviceID === "function") deviceId = Hisense_GetDeviceID();
    } catch (e) {
      deviceId = "06e16c5a-f9cc-f25d-4d8d-c2c0280b927";
    }

    return deviceId;
  },

  async getModel() {
    return "HISENSE TV";
  },

  async getModelCode() {
    return "";
  },

  async getRealModel() {
    try {
      if (typeof Hisense_GetModelName === "function") deviceRealModel = Hisense_GetModelName();
    } catch (e) {
      deviceRealModel = "";
    }

    return deviceRealModel;
  },

  async getPlatform() {
    return "vidaa";
  },

  async getServerVersion() {
    return serverVersion;
  },

  async getYear() {
    return "";
  },

  async supports4K() {
    return false;
  },

  async getFirmwareVersion() {
    try {
      if (typeof Hisense_GetFirmWareVersion === "function") deviceFirmwareVersion = Hisense_GetFirmWareVersion();
    } catch (e) {
      deviceFirmwareVersion = "";
    }
    return deviceFirmwareVersion;
  },

  getManufacturer() {
    return "HISENSE";
  },

  getType() {
    return "TV";
  }
};
